import {
  MAINTENANCE_PATH,
  shouldRedirectToMaintenance,
} from '~/utils/maintenance/maintenance';

export default function ({ redirect, route }) {
  if (!shouldRedirectToMaintenance(route.path)) {
    return;
  }
  redirect(MAINTENANCE_PATH);
}
